<!--发起调拨页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256">
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>

      <p v-show="uname" style="color: red"><span>操作人：</span>{{uname}}<span>正在操作</span>
        <span @click="unlock"
              style="color: blue;cursor: pointer;">&nbsp;解除锁定</span>
      </p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">发&nbsp;&nbsp;货&nbsp;&nbsp;仓：</td>
          <td width="240">
            <el-select v-model="cangkucode" placeholder="请选择" size="mini" @change="changesend" style="width: 160px">
              <el-option
                v-for="item in jxcstoreDatasend"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
            <el-select v-model="warehouse" placeholder="请选择库位" size="mini" style="width: 120px" v-if="warehousearr.length>1&&cangkucode" @change="changewarehouse">
              <el-option v-for="item in warehousearr" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;址：</td>
          <td >{{addresssend!=null?addresssend:""}}</td>
          <!--<td align="right" width="60">电&nbsp;&nbsp;&nbsp;话:</td>-->
          <!--<td width="140">{{linktelsend!=null ?linktelsend:" "}}-->
          <!--</td>-->
        </tr>

        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">收&nbsp;&nbsp;货&nbsp;&nbsp;仓：</td>
          <td width="140">
            <el-select v-model="cangkucode2" placeholder="请选择" size="mini" @change="changereceive" style="width: 160px">
              <el-option
                v-for="item in jxcstoreDatareceive"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{addressreceive!=null?addressreceive:""}}</td>
          <!--<td align="right" width="60">电&nbsp;&nbsp;&nbsp;话:</td>-->
          <!--<td width="140">{{linktelreceive!=null ? linktelreceive:" "}}-->
          <!--</td>-->
        </tr>
        <tr class="noborder" style="height: 26px" v-if="jinjia!=80&&isRouterAlive">
          <td align="right">商&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td colspan="2">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="600"
                        :treeHeight="500" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td>
            <el-button type="primary" @click="initnum" size="mini">一键补货</el-button>
            <span>编码：{{form.seedcode}}</span>
          </td>
          <!--<td align="right">时&nbsp;&nbsp;&nbsp;间:</td>-->
          <!--<td>-->
          <!--</td>-->
        </tr>
        <tr class="noborder" style="height: 26px" v-if="jinjia==80&&isRouterAlive">
          <td align="right">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</td>
          <td colspan="2">
            <CommonTree ref="treeSeedleibie" :inputSize="'mini'" :defineDataSource="true" @bindData="jinjiabindData"
                        :treeWidth="550" style="width: 70%;display: inline-block"
                        :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                        :treeHeight="500" :searchText="form.seedname"
                        @check="jingjiachecktree1"></CommonTree>
            <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择
            </el-button>
          </td>
          <td>
            <el-button type="primary" @click="addFrame" size="mini">增加</el-button>
            <!--<el-button type="primary" @click="initnum" size="mini">一键补货</el-button>-->
            <span>编码：{{form.seedcode}}</span>
          </td>
        </tr>
        <tr class="noborder" style="height: 26px;display: none" v-if="false">
          <td align="right">物&nbsp;&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-model="logisticsco" placeholder="请选择" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </td>
          <td align="right">单&nbsp;&nbsp;&nbsp;号：</td>
          <td>
            <el-input v-model="logisticsnum" auto-complete="off" required="true" size="mini"
                      style="width: 180px;" placeholder="请填写发货单号"></el-input>
          </td>
        </tr>
        <tr class="noborder" v-show="showerweitable">
          <td colspan="4">
            <TwoDimensionalTable ref="referweibiao" :precision="0" :positive="true" :cutHeight="300" :erweitable="erweitable" :topInfoData="storeinfo"
            ></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="4" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :precision="0" :positive="true" :cutHeight="311" :erweitable="erweitableright"
                                   :topInfoData="storeinforight"></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :precision="0" :positive="true" :cutHeight="311" :erweitable="erweitableleft"
                                   :topInfoData="storeinfoleft"></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
        <tr v-show="shownumber">
          <td align="right">数&nbsp;&nbsp;&nbsp;量：</td>
          <td style="margin-bottom: 10px;margin-top: 10px">
            <el-input-number :controls="false" style="width: 100%" size="small" v-model="totalnumber" onfocus="this.select()"></el-input-number>
          </td>
        </tr>
        <tr v-if="jinjia==80">
          <td colspan="4" style="text-align: right">总数:{{totalnumber}}</td>
        </tr>
        <tr class="noborder" v-if="jinjia==80">
          <td colspan="4">
            <el-table
              :data="tableData"
              :height="tableHeight(300)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>

              <el-table-column
                prop="seedcode"
                label="编码"  :show-overflow-tooltip="true"
                align="center"
                width="90"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                align="center"
                width="130"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                align="center"
                width="130"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="100"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event)"
                            @change="totalNumber"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="130">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="4">
            <textarea style="width: 100%;height: 60px" v-model="remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="lock&&paramqrcodescan&&(showerweitable||showzuoyoutable)&&cangkucode&&cangkucode2&&cangkucode!=cangkucode2&&form.seedcode" :loading="loading">扫码发货</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="lock&&canedit">{{buttonname}}</el-button>
      <el-button type="warning" @click="importEdit" size="mini" v-if="showerweitable">二维表导入</el-button>
      <el-button type="warning" @click="importList" size="mini" v-if="showerweitable">列表导入</el-button>
      <a href="./static/file/镜片导入格式.xls" v-if="showerweitable">下载模板</a>
      <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
    </div>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
    <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelectADD"></MakeInventoryFrameAdd>
    <QRCodeScan ref="QRCodeScan1" @scancodeedit="afterQRCodeScan"></QRCodeScan>

  </el-dialog>
</template>
<script>
  import {sortByKey} from '@/api/dateUtil';
  import {buyorderdetaillist} from '@/api/set/csagreement';
  import {getRemark} from '@/plugin/ordercommon'
  import MakeInventoryFrameAdd from './MakeInventoryFrameAdd';
  import {listgoodsframe, getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import {checkModuleRight} from '@/api/login'
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getGoodsNeedBuy, getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import BatchBuyFormProperties from '@/components/testorder/buyagreement/BatchBuyFormProperties'
  import {getDetail,saveAllocationStore} from '@/api/set/allocation';
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersavedetail, jxcstorelist, getpcustomerserial
  } from '@/api/set/csagreement';

  import {getListData} from '@/api/set/jxcstore'
  import {getListDatabyinpd, getListDataall} from '@/api/set/jxcstore';
  import {saveData} from '@/api/set/allocation';
  import {getParameterDetail} from '@/api/set/parameter';
  import {saveData as logsaveData, getListData as logListData, lockremove} from '@/api/set/handlelog';
  import QRCodeScan from '@/components/testorder/buyagreement/QRCodeScan';
  import {listBar} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: 'AllocationEditNew',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        buttonname: '',
        userInfoModel: {},
        loading: false,
        loadbylist: false,
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        erweitable: [],//二维表
        shownumber:false,
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        costpricebook: {},
        paramqrcodescan:false,
        dialogFormVisible: false,
        title: "",
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: '',
        maxmonth: '',
        remark: '',
        cangkucodes: [],
        unitguid: '',
        jxcstoreDatareceive: [],
        jxcstoreDatasend: [],
        warehousearr:[],
        warehouse:'',
        warehousename:'',
        cangkucode: '',
        cangkuname: '',
        cangkucode2: '',
        cangkuname2: '',
        addresssend: '',
        linktelsend: '',
        addressreceive: '',
        linktelreceive: '',
        tableData1: [],
        tableData: [],//镜架使用
        column: [],
        filltemplate: '',
        controlData: '',
        showtitle1: "none",
        showzuoyoutable: false,
        showerweitable: false,
        logisticsco: '',
        logisticsnum: '',
        seedinfo: '',
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          erpserial: "",
        },
        isupdate: false,
        updatecz: 0,
        parameterData: [],
        categorycode: '',
        storeinfo: [],//库存信息
        storeinforight: [],//右库存信息
        storeinfoleft: [],//左库存信息
        independentserial: '',//仓库对应的核算部门
        lock: true,//锁定订单
        canedit:true,
        uname: '',//正在操作的人
        jinjia: '',//镜架调拨
        seedcodeData: [],//选择类别后的商品
        totalnumber: 0,//镜架 调拨总数
        isRouterAlive: false,
      }

    },
    methods: {
      importList(){
        this.loadbylist = true;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      //导入二维表
      importEdit() {
        this.loadbylist = false;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              if(this.loadbylist) {
                data.forEach((item) => {
                  var pg = JSON.parse(item['光度']);
                  pg.P = parseInt(item['数量']);
                  arr.push(pg)
                })
              }else {
                data.forEach((item) => {
                  let Y = ""
                  for (let X in item) {
                    obj = {}
                    if (X == "球\\柱") {
                      Y = parseFloat(item[X]).toFixed(2)
                    } else {
                      if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                        obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": Math.abs(parseFloat(item[X]))}
                        arr.push(obj)
                      }
                    }
                  }
                })
              }
            }
            this.BookContent = arr
            this.createPriceBook()
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      delivergoodsScan() {//扫码发货
        if (this.warehousearr.length > 1 && !this.warehouse) {
          this.errorMessag('库位必须选择！')
          return
        }
        var arr = []
        for (let i in this.erweitable) {
          let temp = this.erweitable[i].filter((t) => {
            return typeof(t.P) != "undefined" && t.P !== "" && parseInt(t.P) !== 0;
          })
          for (let j in temp) {
            for (let m = 0; m < temp[j].P; m++) {
              arr.push({
                seedcode: this.form.seedcode,
                seedname: this.form.seedname,
                packagesize: '{"X":"' + (temp[j].X.toFixed(2)) + '","Y":"' + (temp[j].Y.toFixed(2)) + '"}',
                storegoodsbarcode: '',starttime: '',endtime: ''
              })
            }
          }
        }
        this.$refs.QRCodeScan1.show({
          cangkucode: this.cangkucode,
          erpserial: this.form.erpserial,
          seedcode: this.form.seedcode,
          goods: arr
        }, true);
      },
      afterQRCodeScan(scancodes) {//扫码后提交(退货时才有)
        var arr = []
        var setV=[];

        for(let i in scancodes){
          var pg=scancodes[i].packagesize;
          var seedcode=scancodes[i].seedcode;
          if(setV.indexOf(pg+seedcode)>-1)
            continue;

          var datas=scancodes.filter(sitem => {
            return sitem.packagesize === pg&&sitem.seedcode === seedcode;
          });
          arr.push({
            seedcode: seedcode,
            seedname: scancodes[i].seedname,
            categorycode: this.categorycode,
            totalnumber: datas.length,
            packagesize: pg
          });
          setV.push(pg+seedcode);
        }
        this.postData(arr,true);
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
        this.loading = false;
      },
      checkCanSelect() {
        if (this.cangkucode == this.cangkucode2) {
          this.error('发货仓、收货仓不能选同一个！')
          return false;
        }

        if (this.form.seedcode && this.form.seedcode.length >= 9) {
          return true;
        } else {
          this.error('请选择品牌或系列！')
          return false;
        }
      },
      addFrame(){
        if (this.checkCanSelect()) {
          this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData,
            {cangkucode:this.cangkucode,cangkuname:this.cangkuname,cangkucode2:this.cangkucode2,cangkuname2:this.cangkuname2})
        }
      },
      //解除锁定
      unlock() {
        var casestepname = '修改调拨';
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.lock = true
            this.uname = ''
            //锁定功能(控制发起采购按钮)
            this.handlelog(casestepname);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //回车跳入下一行
      validateCounts(row, index, e) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[Object.keys(this.$refs)[index + 1]].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[Object.keys(this.$refs)[index - 1]].focus();
        }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.erpserial = this.form.erpserial
        handlelog.isopen = 1
        if (this.buttonname == '保存') {
          handlelog.casestepname = casestepname
          handlelog.remark = '修改调拨'
        }
        logsaveData(handlelog).then(response => {
        })
      },
      //绑定库存
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        this.storeinfoleft=[];
        this.storeinforight=[];
        this.storeinfo=[];

        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          cangkucode: this.cangkucode,
          warehouse: this.warehouse ? this.warehouse : null,
          calculateStore: "1",
          overcomeerpserial: this.isupdate?this.form.erpserial:'',
        }).then(resStore => {
          if (resStore.data.obj.length > 0) {
            resStore.data.obj.forEach(o => {
              if (o.packagesize) {
                let ob = JSON.parse(o.packagesize)
                ob.P = o.subtractnum - o.deliverying;// + o.transfernum;
                if (ob.type == 'L') {
                  this.storeinfoleft.push(ob);
                } else if (ob.type == "R") {
                  this.storeinforight.push(ob);
                } else {
                  this.storeinfo.push(ob);
                }
              }
            })
          } else {

          }
          this.createPriceBook()
        }).catch((error) => {
          console.log(error)
        });


      },

      getTitle() {
        return this.userInfoModel.tenantname + "调拨单";
      },

      //一键补货
      initnum() {
        var seedcode = ''
        if (this.jinjia == 80) {
          if (this.tableData.length == 0) {
            this.$message({
              message: '请先选择镜架具体商品',
              type: 'info'
            })
            return
          } else {
            for (let i in this.tableData) {
              if (i == 0) {
                seedcode = this.tableData[i].seedcode + ','
              } else {
                seedcode = ',' + this.tableData[i].seedcode
              }
            }
          }
        }
        this.BookContent = []
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        //收货仓库库存需补货的库存不能大于发货仓库的现有库存
        if (this.form.seedcode) {
          //收货仓库的值，取收货仓库的maxstore
          getGoodsNeedBuy({
              seedcode: this.jinjia == 80 ? seedcode : this.form.seedcode,
              cangkucode: this.cangkucode2,
              minyear: yearnow,
              minmonth: monthnow,
              maxyear: yearnow,
              maxmonth: monthnow,
              nostock: 1,//产品分类（单选）
            },
          ).then(response => {
            var tabledata = response.data.obj
            for (let i in tabledata) {
              if (tabledata[i].maxstore > 0) {
                // console.log(JSON.stringify(tabledata[i]))
              }
            }
            //取发货仓库的当前库存subtractnum
            getGoodsNeedBuy({
                seedcode: this.jinjia == 80 ? seedcode : this.form.seedcode,
                cangkucode: this.cangkucode,
                minyear: yearnow,
                minmonth: monthnow,
                maxyear: yearnow,
                maxmonth: monthnow,
                nostock: 1,//产品分类（单选）
              },
            ).then(response => {
              //左右眼二维表显示
              if (this.filltemplate == 30) {
                for (let j in tabledata) {
                  for (let i in response.data.obj) {
                    if (tabledata[j].packagesize == response.data.obj[i].packagesize) {
                      let subtractnum = response.data.obj[i].subtractnum - response.data.obj[i].deliverying;//发货仓 需要扣除待发货的数量
                      let num = tabledata[j].maxstore > subtractnum ? subtractnum : tabledata[j].maxstore

                      if (JSON.parse(response.data.obj[i].packagesize)["type"] == "L") {
                        this.BookContentLeft.push({
                          X: JSON.parse(response.data.obj[i].packagesize)["X"],
                          Y: JSON.parse(response.data.obj[i].packagesize)["Y"],
                          type: JSON.parse(response.data.obj[i].packagesize)["type"],
                          P: num <= 0 ? '' : num,
                        })
                        break
                      } else {
                        this.BookContentRight.push({
                          X: JSON.parse(response.data.obj[i].packagesize)["X"],
                          Y: JSON.parse(response.data.obj[i].packagesize)["Y"],
                          type: JSON.parse(response.data.obj[i].packagesize)["type"],
                          P: num <= 0 ? '' : num,
                        })
                      }
                      break
                    }
                  }
                }
              } else if (this.jinjia == 80) {
                for (let j in tabledata) {
                  for (let i in response.data.obj) {
                    if (tabledata[j].seedcode == response.data.obj[i].seedcode&&tabledata[j].packagesize == response.data.obj[i].packagesize) {
                      let subtractnum = response.data.obj[i].subtractnum - response.data.obj[i].deliverying;//发货仓 需要扣除待发货的数量
                      let num = tabledata[j].maxstore > subtractnum ? subtractnum : tabledata[j].maxstore
                      tabledata[j].totalnumber = num
                      break
                    }
                  }
                }
              } else {
                // for (let i in response.data.obj) {
                //   if ((JSON.parse(response.data.obj[i].packagesize)["X"] == "0.00" && JSON.parse(response.data.obj[i].packagesize)["Y"] == "4.00") ||
                //     (JSON.parse(response.data.obj[i].packagesize)["X"] == "0.00" && JSON.parse(response.data.obj[i].packagesize)["Y"] == "3.75")) {
                //     console.log(JSON.stringify(response.data.obj[i]))
                //   }
                // }
                for (let j in tabledata) {
                  for (let i in response.data.obj) {
                    if (tabledata[j].packagesize == response.data.obj[i].packagesize) {
                      let subtractnum = response.data.obj[i].subtractnum - response.data.obj[i].deliverying;//发货仓 需要扣除待发货的数量
                      let num = tabledata[j].maxstore > subtractnum ? subtractnum : tabledata[j].maxstore
                      if ((JSON.parse(response.data.obj[i].packagesize)["X"] == "0.00" && JSON.parse(response.data.obj[i].packagesize)["Y"] == "4.00") ||
                        (JSON.parse(response.data.obj[i].packagesize)["X"] == "0.00" && JSON.parse(response.data.obj[i].packagesize)["Y"] == "3.75")) {
                        // console.log(JSON.stringify(response.data.obj[i]))
                        // console.log(num)
                      }

                      this.BookContent.push({
                        X: JSON.parse(response.data.obj[i].packagesize)["X"],
                        Y: JSON.parse(response.data.obj[i].packagesize)["Y"],
                        P: num <= 0 ? '' : num,
                      })
                      break
                    }
                  }
                }
              }
              if (this.jinjia != 80)
                this.getXYRange()
            })
          })
        } else {
          this.$message({
            message: '请选择货品',
            type: 'info'
          })
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      checktree1(guids, names, arr) {
        this.form.seedcode = guids
        this.form.seedname = names
        this.filltemplate = arr[0].attributes.filltemplate
        this.costpricebook = {}
        this.BookContent = []
        this.categorycode = arr[0].parentId;
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.filltemplate == '30') {//左右眼
          this.showzuoyoutable = true
          this.showerweitable = false
          this.shownumber = false
        } else {
          if (this.filltemplate == '40') {//数量类型
            this.showzuoyoutable = false;
            this.showerweitable = false;
            this.shownumber = true;
            return;
          } else {
            this.showzuoyoutable = false
            this.showerweitable = true
            this.shownumber = false
          }
        }
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }
        //比对已选数据
        for (let i = 0; i < this.seedgoods.length; i++) {
          if (this.seedgoods[i].seedcode == this.form.seedcode) {
            this.BookContent = this.seedgoods[i].BookContent
            this.index = i
            break
          }
        }
        this.getXYRange()
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'10;20;30;40'})
        })
      },
      jingjiachecktree1(guids, names, arr) {
        this.seedcodeData = []
        if (guids.length < 9) {
          this.$message.error('请选择品牌或系列!');
          this.$refs.treeSeedleibie.reset();
          return;
        }

        this.form.seedcode = guids
        this.form.seedname = names
        // this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.filltemplate = arr[0].attributes.filltemplate

        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            //参数  true 显示库存，seedcode分类，cangkucode 发货仓库，seedcodeData 分类下的商品
            this.addFrame();
            //this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.cangkucode, this.seedcodeData, "");

          } else {
            this.$message({
              message: '该系列没有备货商品',
              type: 'warning'
            })
            return
          }

        }).catch((error) => {
          console.log(error)
        });

      },
      //商品树
      jinjiabindData() {
        this.$refs.treeSeedleibie.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'80',hideseed:'1'})
        })

      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("请先选择商品分类");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 发货仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.cangkucode, this.seedcodeData, "")
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      getXYRange() {
        this.storeinfoleft = [];
        this.storeinforight = [];
        this.storeinfo = [];
        getPrice({
          seedcode: this.form.seedcode,
          filterType: 'cost'
        }).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          if (this.userInfoModel.independentserial == "" || this.independentserial == this.userInfoModel.independentserial) {
            if (this.form.seedcode) {
              this.bindStore()
            }
          } else {
            this.createPriceBook()
          }
        })
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color)
            {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
            })
          }
        }
        //从小到大排序
       this.sortTable();
        this.totalNumber()
        if (count > 0) {
          this.$message({
            message: "商品已存在！",
            type: 'info'
          })
        }

      },
      sortTable(){
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
      },
      afterSelectADD(arr){
        for (var i in arr) {
          var hasValue = false;
          for (var j in this.tableData) {
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].M && this.tableData[j].color == arr[i].C)
            {//在库存里的
              this.tableData[j].totalnumber+=arr[i].P;
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].C,
              model:arr[i].M,
              categorycode: '',
              totalnumber: arr[i].P,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].M+'","C":"'+arr[i].C+'"}',
              costprice:arr[i].costprice,
              barcodes:[]
            })
          }
        }
        this.sortTable();
        this.totalNumber();
      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      createPriceBook() {
        if (this.filltemplate == 30) {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft, '', this.storeinfoleft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight, '', this.storeinforight)
        } else {
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent, '', this.storeinfo)
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show(item) {
        this.dialogSeeVisible = true;
      },
      changesend(val) {
        for (let i in this.jxcstoreDatasend) {
          if (this.jxcstoreDatasend[i].cangkucode == val) {
            this.cangkuname = this.jxcstoreDatasend[i].cangkuname;
            this.addresssend = this.jxcstoreDatasend[i].address
            this.linktelsend = this.jxcstoreDatasend[i].tel;
            this.independentserial = this.jxcstoreDatasend[i].independentserial;
            this.setWarehouse(this.jxcstoreDatasend[i]);
            this.setXY();
          }
        }
      },

      changewarehouse(val){
        this.warehouse = val;
        for(let i in this.warehousearr){
          if(this.warehousearr[i].serial==val){
            this.warehousename = this.warehousearr[i].name;
            break;
          }
        }
        this.setXY();
      },
      setXY(){
        if (( this.independentserial == this.userInfoModel.independentserial) || this.userInfoModel.independentserial == "") {
          if (this.form.seedcode) {
            this.bindStore()
          }
        } else {
          this.storeinfoleft = [];
          this.storeinforight = [];
          this.storeinfo = [];
          this.getXYRange()
        }
      },
      setWarehouse(storeinfo) {
        this.warehouse = '';
        this.warehousename = '';
        this.warehousearr = [];
        if (storeinfo.warehouse) {
          this.warehousearr = JSON.parse(storeinfo.warehouse);
          if (this.warehousearr <= 1) {
            this.warehousearr = [];
          }
        }
      },
      changereceive(val) {
        for (let i in this.jxcstoreDatareceive) {
          if (this.jxcstoreDatareceive[i].cangkucode == val) {
            this.cangkuname2 = this.jxcstoreDatareceive[i].cangkuname
            this.addressreceive = this.jxcstoreDatareceive[i].address
            this.linktelreceive = this.jxcstoreDatareceive[i].tel
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      }
      ,
      errorMessag(msg) {
        this.$message({
          message: msg,
          type: 'warning'
        })
        this.loading = false;
      },
      saveData() {
        //取出对应的表单详情和数量
        var arr = [];
        if (this.jinjia == 80) {//镜架调拨
          for (let i in this.tableData) {
            var obj = {}
            obj.seedcode = this.tableData[i].seedcode
            obj.packagesize = this.tableData[i].packagesize
            obj.seedname = this.tableData[i].seedname
            obj.categorycode = this.tableData[i].categorycode
            if (parseInt(this.tableData[i].totalnumber) !== 0) {
              obj.P = this.tableData[i].totalnumber
              arr.push(obj)
            }
          }
        } else if (this.filltemplate == "30") {//左右眼
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {
              t.type = "L"
              return typeof(t.P) != "undefined" && t.P !== "" && parseInt(t.P) !== 0;
            })
            arr = arr.concat(temp)
          }
          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              t.type = "R"
              return typeof(t.P) != "undefined" && t.P !== "" && parseInt(t.P) !== 0;
            })
            arr = arr.concat(temp)
          }
        }
        else {//非左右眼
          if (this.shownumber) {
            if (this.totalnumber > 0) {
              var obj = {}
              obj.seedcode = this.form.seedcode
              obj.seedname = this.form.seedname
              obj.P = this.totalnumber
              arr.push(obj)
            }
          } else {
            for (let i in   this.erweitable) {
              let temp = this.erweitable[i].filter((t) => {
                return typeof(t.P) != "undefined" && t.P !== "" && parseInt(t.P) !== 0;
              })
              arr = arr.concat(temp)
            }
          }
        }
        if (arr.length == 0) {
          this.errorMessag('请填写调拨数量！')
          return
        }
        if (this.warehousearr.length > 1 && !this.warehouse) {
          this.errorMessag('库位必须选择！')
          return
        }

        if (!this.cangkucode) {
          this.errorMessag('请选择发货仓库！')
          return
        }

        if (!this.cangkucode2) {
          this.errorMessag('请选择收货仓库！')
          return
        }

        // if (this.cangkucode == this.cangkucode2) {
        //   this.errorMessag('发货仓库、收货仓库不能相同！')
        //   return
        // }
        if (arr.length != 0) {
          let jxcformdetails = [];
          if (this.jinjia == 80) {
            for (let i in arr) {
              jxcformdetails.push(
                {
                  seedcode: arr[i].seedcode,
                  seedname: arr[i].seedname,
                  categorycode: arr[i].categorycode,
                  packagesize: arr[i].packagesize,
                  totalnumber: arr[i]["P"]
                }
              )
            }
          } else if (this.shownumber) {
            jxcformdetails.push(
              {
                seedcode: this.form.seedcode,
                seedname: this.form.seedname,
                totalnumber: this.totalnumber
              }
            )
          } else {

            for (let i in arr) {
              let packsize = {};
              packsize = {
                X: arr[i]["X"].toFixed(2) + "",
                Y: arr[i]["Y"].toFixed(2) + ""
              }
              if (this.filltemplate == "30") {
                packsize["type"] = arr[i].type
              }
              jxcformdetails.push(
                {
                  seedcode: this.form.seedcode,
                  seedname: this.form.seedname,
                  categorycode: this.categorycode,
                  totalnumber: arr[i]["P"],
                  packagesize: packsize
                }
              )
            }
            // this.seedinfo=this.form.seedname+','+this.form.seedcode
          }

          this.postData(jxcformdetails);
        } else {
          this.errorMessag('请填写调拨单明细！')
        }
      }
      ,
      postData(jxcformdetails,scan){
        saveData({
          unitguid: this.unitguid,
          seedgoods: JSON.stringify(jxcformdetails),
          cangkucode: this.cangkucode,
          cangkuname: this.cangkuname,
          warehouse:this.warehouse,
          warehousename:this.warehousename,
          cangkucode2: this.cangkucode2,
          cangkuname2: this.cangkuname2,
          remark: this.remark,
          seedcode: this.form.seedcode,
          seedname: this.form.seedname,
          updatecz: this.updatecz,
          logisticsco: this.logisticsco,
          logisticsnum: this.logisticsnum,
          seedinfo: this.seedinfo,
          categorycode: this.categorycode,
          erpserial: this.form.erpserial,
          filltemplate: this.jinjia == 80 ? 80 : "",
          noaudit:scan?1:0
        }).then(response => {
          if (response.data.code == 0) {
            if (scan && this.$refs.QRCodeScan1) {//退货出库的时候需要保存 唯一码
              this.$refs.QRCodeScan1.saveQRCode(response.data.erpserial);
              if (response.data.code == 0) {
                //做发货操作
                saveAllocationStore({
                  unitguid: response.data.unitguid,
                  logisticsnum: '',
                  logisticsco: ''
                }).then(resSend => {
                  this.$message({
                    message: '已生成调拨单，出库完成！',
                    type: 'success'
                  })
                });
              }else{
                this.$message.error(response.data.msg)
              }
              this.$emit('bindGrid', this.buttonname == '通过');
              this.dialogSeeVisible = false;
            } else {
              this.$message({
                message: this.userInfoModel.independentserial ? '保存成功，需要总部订单岗审核！' : '保存成功',
                type: 'success'
              })
              this.$emit('bindGrid', this.buttonname == '通过');
              this.dialogSeeVisible = false;
            }
          }else {
            this.errorMessag(response.data.msg)
          }
          //刷新列表
        });
        //
      },
      initData(item, isupdate, filltemplate) {
        this.initForm()
        this.jinjia = filltemplate//等于40时 才是镜架镜架调拨
        this.reload()
        //通过isupdate判读是否是进行修改的操作
        if (isupdate && isupdate == 1) {
          this.isupdate = true
          this.updatecz = 1
          this.unitguid = item.unitguid
          getDetail({unitguid: item.unitguid}).then(response => {
            this.controlData = response.data.obj;
            if (this.controlData.status == -20 && !this.userInfoModel.independentserial) {//总部订单岗审核
              this.buttonname = '通过'
            }
            this.form.erpserial = response.data.obj.erpserial;
            if(this.paramqrcodescan&&this.form.erpserial) {
              listBar({outordernum: this.form.erpserial}).then(response => {
                if (response.data.obj.rows.length > 0) {
                  this.canedit = false;//已扫码不允许再修改
                }
              });
            }
            if (this.controlData.filltemplate == 40){//数量类型
              this.showzuoyoutable = false
              this.shownumber = true
              this.showerweitable = false
              this.totalnumber=this.controlData.seedgooddlist[0].totalnumber
              this.form.seedcode = this.controlData.seedgooddlist[0].seedcode
              this.form.seedname = this.controlData.seedgooddlist[0].seedname
            }else if (this.controlData.filltemplate == 80) {//镜架 调拨
              this.jinjia = this.controlData.filltemplate
              this.form.seedcode = this.controlData.seedcode
              this.form.seedname = this.controlData.seedname
              for (let i in this.controlData.seedgooddlist) {
                var pack = JSON.parse(this.controlData.seedgooddlist[i].packagesize)
                this.tableData.push({
                  seedcode: this.controlData.seedgooddlist[i].seedcode,
                  seedname: this.controlData.seedgooddlist[i].seedname,
                  color: pack.C,
                  model: pack.M,
                  categorycode: this.controlData.seedcode,
                  totalnumber: this.controlData.seedgooddlist[i].totalnumber,
                  formproperty: '[{}]',
                  packagesize: this.controlData.seedgooddlist[i].packagesize,
                })
              }
              this.totalNumber()
              listgoodsframe({
                categorycode: this.form.seedcode,
                filltemplate: '80',
              }).then(response => {
                this.seedcodeData = response.data.obj
              });

            } else {
              this.form.seedcode = this.controlData.seedgooddlist[0].seedcode
              this.form.seedname = this.controlData.seedgooddlist[0].seedname
              if (this.controlData.bookcontent[0]["type"]) {
                this.showzuoyoutable = true
                this.showerweitable = false
                this.shownumber=false
                this.filltemplate = 30
              } else {
                  this.showzuoyoutable = false
                  this.shownumber = false
                  this.showerweitable = true
              }
              var bookcontent = this.controlData.bookcontent
              if (this.showzuoyoutable) {
                for (let i in bookcontent) {
                  if (bookcontent[i].type == "L") {
                    this.BookContentLeft.push(bookcontent[i])
                  }
                  if (bookcontent[i].type == "R") {
                    this.BookContentRight.push(bookcontent[i])
                  }
                }
              }
              if (this.showerweitable) {
                this.BookContent = bookcontent
              }
            }
            getListDataall().then(response => {
              this.jxcstoreDatasend = response.data.obj
              for (let i in this.jxcstoreDatasend) {
                if (this.jxcstoreDatasend[i].cangkucode == this.controlData.cangkucode) {
                  this.independentserial = this.jxcstoreDatasend[i].independentserial
                  this.setWarehouse(this.jxcstoreDatasend[i]);
                }
              }

              this.cangkucode = this.controlData.cangkucode
              this.cangkuname = this.controlData.cangkuname
              this.warehouse= this.controlData.warehouse
              this.warehousename= this.controlData.warehousename


              this.jxcstoreDatareceive = response.data.obj
              this.cangkucode2 = this.controlData.cangkucode2
              this.cangkuname2 = this.controlData.cangkuname2
            })
            this.remark = JSON.parse(this.controlData.remark)[0].msg
            //判断是否有成本价
            if(this.showerweitable||this.showzuoyoutable)
               this.getXYRange()
            //查询订单是否有人正在操作
            if (this.buttonname == '保存') {
              logListData({
                erpserial: response.data.obj.erpserial,
              }).then(response => {
                if (response.data.obj.length > 0) {
                  //修改调拨单时需要 是否有人在操作此订单
                  //当前登陆人与日志表uname不一致时锁定采购订单
                  for (let i = 0; i < response.data.obj.length; i++) {
                    if (response.data.obj[i].casestepname == '修改调拨' || response.data.obj[i].casestepname == '调拨发货') {
                      if (response.data.obj[i].uname && this.userInfoModel.uname != response.data.obj[i].uname) {
                        this.lock = false;
                        this.uname = response.data.obj[i].uname;
                        break;
                      }
                    }
                  }
                }
                if (this.lock) {
                  //锁定功能
                  this.handlelog('修改调拨');
                }
              })
            }
          });
        } else {
          this.getXYRange()
          getListDataall().then(response => {
            this.jxcstoreDatasend = response.data.obj
            this.independentserial = this.jxcstoreDatasend[0].independentserial
            this.cangkucode = this.jxcstoreDatasend[0].cangkucode
            this.cangkuname = this.jxcstoreDatasend[0].cangkuname
            this.addresssend = this.jxcstoreDatasend[0].address
            this.linktelsend = this.jxcstoreDatasend[0].tel


            this.setWarehouse(this.jxcstoreDatasend[0]);

            this.jxcstoreDatareceive = response.data.obj
            if (item) {
              this.form.seedcode = item.seedcode
              this.form.seedname = item.seedname
              this.cangkucode2 = item.cangkucode
              this.cangkuname2 = item.cangkuname
              this.addressreceive = ''
              this.linktelreceive = ''
              this.filltemplate = item.filltemplate
              if (item.filltemplate == 30) {
                this.showzuoyoutable = true,
                  this.showerweitable = false
              } else {
                this.showzuoyoutable = false,
                  this.showerweitable = true
              }
              this.getXYRange()
              this.initnum()
            } else {
              var storeInfo = this.jxcstoreDatareceive[0];
              if (this.userInfoModel.independentserial) {
                for (let i in this.jxcstoreDatareceive) {
                  if (this.jxcstoreDatareceive[i].independentserial == this.userInfoModel.independentserial) {
                    storeInfo = this.jxcstoreDatareceive[i];
                    break;
                  }
                }
              }
              this.cangkucode2 = storeInfo.cangkucode
              this.cangkuname2 = storeInfo.cangkuname
              this.addressreceive = storeInfo.address
              this.linktelreceive = storeInfo.tel
            }
          })

        }
      },
      initForm() {
        this.loading = false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.buttonname = '保存'
        this.canedit=true;
        this.erweitable = []
        this.BookContent = []
        this.form.seedcode = ""
        this.form.seedname = ''
        this.form.erpserial=''
        this.tableData1 = []
        this.remark = ''
        this.filltemplate = ''
        this.BookContentRight = []
        this.BookContentLeft = []
        this.cangkucode = ''
        this.cangkuname = ''
        this.cangkucode2 = ''
        this.cangkuname2 = ''
        this.isupdate = false
        this.showerweitable = false
        this.showzuoyoutable = false
        this.shownumber = false
        this.updatecz = 0
        this.seedinfo = ''
        this.logisticsco = ''
        this.categorycode = ''
        this.storeinfo = []
        this.storeinfoleft = []
        this.storeinforight = []
        this.uname = ''
        this.lock = true
        this.jinjia = ''
        this.seedcodeData = []
        this.tableData = []
        this.totalnumber = 0
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      checkModuleRight({name: 'qrcodescan'}).then(reponse => {//允许使用扫码发货
        this.paramqrcodescan = reponse.data.code == 0;
      });
      //切换仓库时调用
      window.refreshErWeiTable = () => {
        this.storeinfo = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.jinjia != 40)
        this.getXYRange()
      }
      // getParameterDetail({paraname: "快递公司"}).then(response => {
      //   this.parameterData = JSON.parse(response.data.obj.paracontent);
      //   this.logisticsco = this.parameterData[0].name
      // })
    },

    components: {
      TwoDimensionalTable,
      BatchBuyFormProperties,
      MakeInventoryFrameAdd,
      QRCodeScan
      //BuyorderDetail
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AllocationEditNew.vue